/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvanceSearchAnalyticsRequestModel } from '../../models/advance-search-analytics-request-model';

export interface CreateAdvancedSearchSystemsAnalytics$Params {
      body?: AdvanceSearchAnalyticsRequestModel
}

export function createAdvancedSearchSystemsAnalytics(http: HttpClient, rootUrl: string, params?: CreateAdvancedSearchSystemsAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createAdvancedSearchSystemsAnalytics.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
createAdvancedSearchSystemsAnalytics.PATH = '/api/advancedsearchanalytics/createadvancedsearchsystemsanalytics';
createAdvancedSearchSystemsAnalytics.METHOD = 'post';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
createAdvancedSearchSystemsAnalytics.ROOTURL = '/portal';
